export const put_data_weapons = (key, data) => ({
    type: 'PUT_DATA_WEAPONS',
    key,
    data
})